module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Half-heart-b888b86874a4df6a568bf023ffc3d115.svg";